<div class="contains-button">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <div class="config-text" style="width: 100%">
        <!-- Nhập nội dung của nút -->
        <mat-form-field style="width: 100%">
          <mat-label> {{'noi_dung' | translate}}</mat-label>
          <textarea matInput
            [ngModel]="staticdata['content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component"
            (ngModelChange)="staticdata['content_' + functionService.selectedLanguageCode] = $event"
            (blur)="updateContent('content');"></textarea>
        </mat-form-field>
        <!-- Nếu nội dung không có thì phải có nhãn -->
        <mat-form-field style="width: 100%" class="aria-label-input" [matTooltip]="'*_giai_thich_aria_label' | translate"
        *ngIf="!staticdata['content_' + functionService.selectedLanguageCode]?.trim()">
          <mat-label>{{'nhan_cua_nut' | translate}}<span style="color: red">*</span></mat-label>
          <textarea matInput
            [ngModel]="staticdata.accessibility?.['aria_label_' + functionService.selectedLanguageCode]"
            (ngModelChange)="staticdata.accessibility['aria_label_' + functionService.selectedLanguageCode] = $event"
            (blur)="updateContent('aria_label', true)"></textarea>
        </mat-form-field>
      </div>
      <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class" [config]="config"
         [staticdata]="staticdata" [textContentClass]="class['button__content']"
        [textWrapperClass]="class['button']">
      </app-text-format-config>

      <div class="color-pick">
        <span class="title w-50">{{'mau_nen' | translate}}</span>
        <input class="input-color w-50" type="button" [cpOKButton]="true" [(colorPicker)]="class['button']['background-color']"
          [style.background]="class['button']['background-color']" (colorPickerClose)="updateObject()"
          [cpWidth]="'230px'" />
      </div>

      <!-- Mở popup so sánh màu tương phản -->
      <button *ngIf="staticdata['content_' + functionService.selectedLanguageCode]"
      nz-row (click)="openColorContrast()" nz-tooltip
      [nzTooltipTitle]="'dung_de_toi_uu_chi_so_accessibility_kha_nang_tiep_can_tren_pagespeed' | translate"
      style="color: #fff; background-color: #00a859; width: 100%; padding: 8px; border-radius: 8px;">
        {{ 'so_sanh_do_tuong_phan_giua_mau_chu_icon_va_mau_nen' | translate }}
      </button>
    </div>
  </ng-container>

  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>

  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- Cấu hình thông số cơ bản của button-->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="button-size">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
      <!-- Cấu hình tái sử dụng thiết kế-->

      <!-- Cấu hình format font name của button -->
      <li nz-submenu nzTitle="{{'dinh_dang_ten_nut' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <div class="container-font">
          <!-- chọn ngôn ngữ đa ngôn ngữ -->
          <div class="field-row mb-3">

          </div>
          <div class="config-text" style="width: 100%">
            <!-- Nhập nội dung của nút -->
            <mat-form-field style="width: 100%">
              <mat-label> {{'noi_dung' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="staticdata['content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component"
                (ngModelChange)="staticdata['content_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('content');"></textarea>
            </mat-form-field>
            <!-- Nếu nội dung không có thì phải có nhãn -->
            <mat-form-field style="width: 100%" class="aria-label-input" [matTooltip]="'*_giai_thich_aria_label' | translate"
            *ngIf="!staticdata['content_' + functionService.selectedLanguageCode]?.trim()">
              <mat-label>{{'nhan_cua_nut' | translate}}<span style="color: red">*</span></mat-label>
              <textarea matInput
                [ngModel]="staticdata.accessibility?.['aria_label_' + functionService.selectedLanguageCode]"
                (ngModelChange)="staticdata.accessibility['aria_label_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('aria_label', true);"></textarea>
            </mat-form-field>
          </div>
          <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class" [config]="config"
             [staticdata]="staticdata" [textContentClass]="class['button__content']"
            [textWrapperClass]="class['button']">
          </app-text-format-config>
          <div class="font-adjusting">
            <div class="row-spacing">
              <span class="title">{{'gian_cach_chu' | translate}}</span>
              <nz-input-number [nzMin]="0" [nzMax]="30" [ngStyle]="{ width: '40%' }" [ngModel]="
                  class['button__content']['letter-spacing'] | vhnumber
                " (nzBlur)="updateClass()" (ngModelChange)="
                  class['button__content']['letter-spacing'] = $event + 'px'
                "></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="30" [ngModel]="class['button__content']['letter-spacing'] | vhnumber"
              (nzOnAfterChange)="updateClass()" (ngModelChange)="
                class['button__content']['letter-spacing'] = $event + 'px'
              "></nz-slider>
          </div>
          <div class="font-adjusting">
            <div class="row-spacing">
              <span class="title">{{'khoang_cach_dong' | translate}}</span>
              <nz-input-number [nzMin]="0" [nzMax]="3" [ngStyle]="{ width: '40%' }" [nzStep]="0.1"
                [(ngModel)]="class['button__content']['line-height']" (nzBlur)="updateClass()"></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="3" [nzStep]="0.1" [(ngModel)]="class['button__content']['line-height']"
              (nzOnAfterChange)="updateClass()"></nz-slider>
          </div>

          <label class="px-1">{{'gian_cach' | translate}}</label>
          <div class="padding">
            <div class="d-flex items">
              <img src="./assets/root/images/system/icons/padding-top.svg" alt="1" width="30px" />
              <nz-input-number [nzMin]="0" [nzMax]="200" style="max-width: 50%" [nzStep]="1"
                [ngModel]="class['button']['padding-top'] | vhnumber" (nzBlur)="updateClassAndWidthHeight()"
                (ngModelChange)="
                  class['button']['padding-top'] = $event + 'px';
                  class['button']['padding-bottom'] = $event + 'px'
                "></nz-input-number>
            </div>
            <div class="d-flex items">
              <img src="./assets/root/images/system/icons/padding-right-left.svg" alt="1" width="30px" />
              <nz-input-number [nzMin]="0" [nzMax]="200" style="max-width: 50%" [nzStep]="1"
                [ngModel]="class['button']['padding-left'] | vhnumber" (nzBlur)="updateClassAndWidthHeight()"
                (ngModelChange)="
                  class['button']['padding-right'] = $event + 'px';
                  class['button']['padding-left'] = $event + 'px'
                "></nz-input-number>
            </div>
          </div>
        </div>
      </li>
      <!-- Cấu hình màu nền của button -->
      <li nz-submenu nzTitle="{{'mau_sac' | translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <div class="container-color">
          <button id="btn-color" *ngFor="let background of backgroundColor; let i = index"
            [ngStyle]="{ 'background-color': background.bgColor }" (click)="chooseBg(background, $event)" nz-tooltip
            [disabled]="config['background-color'].gradient_check"></button>
        </div>
        <div class="color-pick">
          <span class="title w-50">{{'chon_mau' | translate}}</span>
          <input class="input-color w-50" type="button" [cpOKButton]="true" [(colorPicker)]="class['button']['background-color']"
            [style.background]="class['button']['background-color']" (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'" [disabled]="config['background-color'].gradient_check" />
        </div>
        <div class="mr-2 mb-4 mt-4 view-more" style="
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 7px;
          ">
          <p class="discover_text" (click)="openViewAll(styles_field[3])"
            style="cursor: pointer; text-align: left; margin: 0">
            {{'mau_gradient' | translate}} &#8594;
          </p>
        </div>
        <!-- Mở popup so sánh màu tương phản -->
        <button *ngIf="staticdata['content_' + functionService.selectedLanguageCode]"
        nz-row (click)="openColorContrast()" nz-tooltip
        [nzTooltipTitle]="'dung_de_toi_uu_chi_so_accessibility_kha_nang_tiep_can_tren_pagespeed' | translate"
        style="color: #fff; background-color: #00a859; width: 100%; padding: 8px; border-radius: 8px;">
          {{ 'so_sanh_do_tuong_phan_giua_mau_chu_icon_va_mau_nen' | translate }}
        </button>
      </li>
      <!-- Cấu hình biểu tượng -->
      <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
        <app-symbol-config [device]="device" [class]="class" [config]="config" [symbolClass]="class['button']"
          [fontSizeIconClass]="class['button__content--icon-wrapper']" [symbolConfig]="config['flex-direction']"
          [objectChoosing]="objectChoosing">
        </app-symbol-config>
      </li>
      <!-- Cấu hình đổ bóng -->
      <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['button']"
          [shadowConfig]="config['box-shadow']" [objectChoosing]="objectChoosing">
        </app-shadow-config>
      </li>
      <!-- Cấu hình hình dạng viền -->
      <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <app-borders-config [device]="device" [class]="class" [borderClass]="class['button']"
          [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[1])">
            {{'mo_rong' | translate}} &#8594;
          </p>
        </div>
      </li>
      <!-- Cấu hình thông báo -->
      <li *ngIf="['AtwButtonSave', 'AtwButtonLogout'].includes(objectChoosing.component)" nz-submenu nzTitle="{{'cau_hinh_thong_bao' | translate}}" [(nzOpen)]="openMap.menu11"
       (nzOpenChange)="openHandler('menu11')">
        <ng-template #notificationBlock let-dataKey="dataKey" let-configKey="configKey" let-label="label">
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label> {{label | translate}}</mat-label>
              <textarea matInput
                [ngModel]="staticdata[dataKey + '_' + functionService.selectedLanguageCode]"
                (ngModelChange)="staticdata[dataKey + '_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent(dataKey)"></textarea>
            </mat-form-field>

            <div style="display:flex; justify-content:space-between; align-items:center">
              <span class="w-50" style="line-height:1.2;">{{ 'thoi_gian_hien_thong_bao' | translate }}</span>
              <nz-input-number
                [nzMin]="2000" [nzMax]="10000" [nzStep]="100"
                [ngStyle]="{ marginLeft: '16px', width: '40%' }"
                [ngModel]="config.duration_noti?.[configKey] | vhnumber"
                (ngModelChange)="config.duration_noti[configKey] = $event"
                (nzBlur)="updateConfig()" class="w-50">
              </nz-input-number>
            </div>
            <hr />
          </div>
        </ng-template>

        <ng-container *ngIf="['AtwButtonLogout'].includes(objectChoosing.component)">
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_notification',
            configKey: 'notification', label: 'noi_dung'
          }"></ng-container>
        </ng-container>

        <ng-container *ngIf="['AtwButtonSave', 'AtwButtonRegister'].includes(objectChoosing.component)">
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_success',
            configKey: 'success',
            label: 'thanh_cong'
          }"></ng-container>
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_error',
            configKey: 'error',
            label: 'khong_thanh_cong'
          }"></ng-container>
        </ng-container>

        <ng-container *ngIf="['AtwButtonRegister'].includes(objectChoosing.component)">
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_mail_valid',
            configKey: 'mail_valid', label: 'email_khong_dung_dinh_dang'
          }"></ng-container>
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_notification',
            configKey: 'notification', label: 'kiem_tra_truong_du_lieu'
          }"></ng-container>
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_email_existed',
            configKey: 'email_existed', label: 'email_da_ton_tai'
          }"></ng-container>
        </ng-container>

        <ng-container *ngIf="['AtwButtonConfirm', 'AtwButtonForgotPassword'].includes(objectChoosing.component)">
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_pass_change_success',
            configKey: 'pass_change_success', label: 'thay_doi_mat_khau_thanh_cong'
          }"></ng-container>
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_pass_inccorect',
            configKey: 'pass_inccorect', label: 'mat_khau_khong_dung'
          }"></ng-container>
        </ng-container>

        <ng-container *ngIf="['AtwButtonForgotPassword', 'AtwBtnLogin'].includes(objectChoosing.component)">
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_email_required',
            configKey: 'email_required', label: 'bat_buoc_nhap_email'
          }"></ng-container>
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_pass_required',
            configKey: 'pass_required', label: 'bat_buoc_nhap_mat_khau'
          }"></ng-container>
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_email_existed',
            configKey: 'email_existed', label: 'email_da_ton_tai'
          }"></ng-container>
        </ng-container>

        <ng-container *ngIf="['AtwBtnLogin'].includes(objectChoosing.component)">
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_login_success',
            configKey: 'login_success', label: 'dang_nhap_thanh_cong'
          }"></ng-container>
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_pass_inccorect',
            configKey: 'pass_inccorect', label: 'mat_khau_khong_dung'
          }"></ng-container>
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_email_auth',
            configKey: 'email_auth', label: 'xac_thuc_email'
          }"></ng-container>
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_email_not_existed',
            configKey: 'email_not_existed', label: 'email_khong_ton_tai'
          }"></ng-container>
          <ng-container *ngTemplateOutlet="notificationBlock; context: {
            dataKey: 'content_noti_reset_pass',
            configKey: 'reset_pass', label: 'reset_mat_khau'
          }"></ng-container>
        </ng-container>
      </li>
      <!-- Cấu hình xoay-->
      <li nz-submenu nzTitle="{{'cau_hinh_xoay' | translate}}" [(nzOpen)]="openMap.menu9"
        (nzOpenChange)="openHandler('menu9')">
        <app-rotate-config [classRotate]="class['button']" [config]="config" [device]="device"
          [objectChoosing]="objectChoosing"></app-rotate-config>
      </li>
      <!-- THÊM LIÊN KẾT -->
      <li *ngIf="!objectChoosing.dynamic_data" nz-submenu nzTitle="{{'lien_ket' | translate}}" [(nzOpen)]="openMap.menu8"
        (nzOpenChange)="openHandler('menu8')">

        <app-link-page-config [staticdata]="staticdata" [id_object]="objectChoosing._id"></app-link-page-config>
      </li>
      <!-- Cấu hình hiệu ứng -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu7" (nzOpenChange)="openHandler('menu7')">
        <app-choose-animations-config [type]="type" [elementChoosing]="objectChoosing" (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
          [cursorClass]="class['button']" [effect_hover]="effect_hover" [customize]="customize" [type]="'object'"
          [effectFileUsing]="'button'">
        </app-choose-animations-config>

      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình object -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config [device]="device" [class]="class" [borderRadiusClass]="class['button']"
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 3">
       <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [staticdata]="staticdata" [id_object]="objectChoosing._id" [customize]="customize"
        [device]="device"></app-animations-config>
    </div>
    <!-- Cấu hình chi tiết màu gradient  -->
    <div class="container-gradient" *ngIf="currentViewAll.index == 4">
      <div class="title-head">
        <p class="text-fill">{{'phoi_mau' | translate}}</p>
        <label nz-checkbox [(ngModel)]="config['background-color'].gradient_check"
          (ngModelChange)="updateBackgroundRgb()"></label>
      </div>
      <div class="list-gradient">
        <button class="btn-gradient" *ngFor="
            let bgGradient of config['background-color']['gradient_arr'];
            let i = index
          " (click)="deleteGradient(i)" [ngStyle]="{ 'background-color': bgGradient }"
          [disabled]="!config['background-color'].gradient_check">
          <i class="delete-icon bi bi-x-circle"></i>
        </button>
      </div>
      <p class="title-head">{{ 'them_mau' | translate }}</p>
      <div class="container_add-gradient">
        <input class="input-color" [cpOKButton]="true" [(colorPicker)]="config['background-color'].background" type="button"
          [disabled]="!config['background-color'].gradient_check"
          [style.background]="config['background-color'].background" (colorPickerClose)="addGradient($event)" />
      </div>
      <p class="title-head">{{ 'huong_phoi_mau' | translate }}</p>
      <button class="gradient-direction" *ngFor="let type of functionService.gradientDirectionList" nz-tooltip
        nzTooltipTitle="{{type.name | translate}}" (click)="chooseOption(type, $event)"
        [disabled]="!config['background-color'].gradient_check"
        [style.background]="'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'"
        [class.active]="config['background-color'].gradient_direction === type.direction">
      </button>
    </div>
  </div>
</div>